var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefu-wrapper"},[_c('title-bar',{attrs:{"title":"蓝湖客服"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefu-iframe"},[_c('iframe',{staticClass:"lanhu-kefu",attrs:{"marginheight":"4.5rem","src":"https://lanhu.kf5.com/kchat","frameborder":"0"}})])
}]

export { render, staticRenderFns }